<template>
    <button class="btn btn-dark my-2" @click="handleBackClick">
        <span class="fa fa-caret-left"></span>
        <span class="fa fa-caret-left"></span>
    </button>
</template>

<script>
export default {
    props: {
        storeLocal: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        handleBackClick() {
            // Set the localStorage value only if storeLocal is true
            if (this.storeLocal) {
                localStorage.setItem('from', 'BackButtonClicked');
            }
            // Navigate back
            this.$router.go(-1);
        }
    }
}
</script>

